"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _withCleanableMounting = require("../components/withCleanableMounting");

var _withStoreProp = _interopRequireDefault(require("./withStoreProp"));

var _excluded = ["store"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var withActivableModel = function withActivableModel(_ref) {
  var _ref$props = _ref.props,
      props = _ref$props === void 0 ? {} : _ref$props,
      modelActivationFunctions = _ref.modelActivationFunctions,
      _ref$onUnmountFuncs = _ref.onUnmountFuncs,
      onUnmountFuncs = _ref$onUnmountFuncs === void 0 ? [] : _ref$onUnmountFuncs,
      _ref$activable = _ref.activable,
      activable = _ref$activable === void 0 ? true : _ref$activable;
  return function (Component) {
    return (0, _withStoreProp.default)(function ActivableModel(_ref2) {
      var store = _ref2.store,
          restProps = (0, _objectWithoutPropertiesLoose2.default)(_ref2, _excluded);
      var Comp = (0, _react.useRef)(null);

      var _useState = (0, _react.useState)(function () {
        var onMountFuncs = modelActivationFunctions(store);

        if (activable) {
          Comp.current = (0, _withCleanableMounting.withCleanableMounting)({
            props: props,
            onMountFuncs: onMountFuncs,
            onUnmountFuncs: onUnmountFuncs
          })(Component);
        } else {
          onMountFuncs.forEach(function (func) {
            return typeof func === 'function' && func();
          });
          Comp.current = Component;
        }

        return true;
      }),
          init = _useState[0];

      return init ? /*#__PURE__*/_react.default.createElement(Comp.current, Object.assign({}, restProps, props)) : null;
    });
  };
};

var _default = withActivableModel;
exports.default = _default;